import { defineStyleConfig } from '@chakra-ui/react'

export const ChakraCollapsibleButton = defineStyleConfig({
  baseStyle: {
    span: { fontSize: 'xs' },
  },
})
